const { Col, Typography } = require('antd');

export const ProductIxoneCertification = ({ fieldList }) => {
  return (
    <>
      <Col>
        <Typography.Paragraph>
          Below is a list of the IX-ONE captured Product(s) linked with image:
        </Typography.Paragraph>
      </Col>
      <Col span={24} style={{ fontWeight: 'bold' }}>
        <ol>
          {fieldList?.length
            ? fieldList.map((productItem, index) => {
                return (
                  <li key={index}>
                    <Typography.Link
                      href={`/product/${productItem?.productId}`}
                      target='_blank'
                    >
                      {productItem?.productId} -{' '}
                      {productItem?.productName || 'No Name'}
                    </Typography.Link>
                  </li>
                );
              })
            : null}
        </ol>
      </Col>
    </>
  );
};
